export function Field({ label, children, hint }) {
  return (
    <label className="block">
      <span className="overline text-foreground/70">{label}</span>
      <div className="mt-2">{children}</div>
      {hint && <span className="mt-1 block font-mono-plex text-[11px] text-foreground/50">{hint}</span>}
    </label>
  );
}

const inputCls =
  "w-full bg-background border-2 border-foreground rounded-lg px-4 py-3 text-base outline-none focus:bg-primary/10 focus:ring-0 transition-colors placeholder:text-foreground/40";

export function TextInput(props) {
  return <input {...props} className={inputCls} />;
}

export function TextArea(props) {
  return <textarea {...props} rows={3} className={inputCls} />;
}

export function SelectInput({ children, ...props }) {
  return (
    <select {...props} className={`${inputCls} appearance-none cursor-pointer`}>
      {children}
    </select>
  );
}
